<template>
  <Listbox v-model="localAnimation">
    <div class="relative mt-1">
      <ListboxButton
        class="relative w-full cursor-default rounded-lg border bg-white py-1 pr-10 pl-2 text-left sm:text-sm dark:bg-slate-600 dark:text-gray-200"
      >
        <span class="flex flex-row items-center gap-2">
          <span class="block truncate text-left capitalize">
            {{
              listAnimations.find(
                (animation) => animation.key === localAnimation
              )?.label
            }}
          </span>
        </span>

        <span
          class="pointer-events-none absolute inset-y-0 right-2 flex items-center"
        >
          <FontAwesomeIcon :icon="['fal', 'chevron-down']" />
        </span>
      </ListboxButton>

      <transition
        leave-active-class="transition duration-100 ease-in"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <ListboxOptions
          class="absolute bottom-0 mb-8 max-h-60 w-full origin-bottom-left overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm dark:bg-slate-400 dark:text-gray-600"
        >
          <ListboxOption
            v-for="listAnimation in listAnimations"
            v-slot="{ active, selected }"
            :key="listAnimation.key"
            :value="listAnimation.key"
            as="template"
          >
            <li
              :class="[
                selected
                  ? 'bg-primary-500 text-contrast-primary'
                  : active
                    ? 'bg-primary-400 text-contrast-primary dark:text-gray-300'
                    : 'text-gray-900',
                'relative cursor-default py-1 pr-4 pl-8 select-none'
              ]"
            >
              <span :class="[selected ? 'font-medium' : 'font-normal']">
                <span class="capitalize">{{ listAnimation.label }}</span>
              </span>
              <span
                v-if="selected"
                class="absolute inset-y-0 left-0 flex items-center pl-3 text-white"
              >
                <FontAwesomeIcon :icon="['fas', 'check']" />
              </span>
            </li>
          </ListboxOption>
        </ListboxOptions>
      </transition>
    </div>
  </Listbox>
</template>

<script>
import { defineComponent } from 'vue'

import {
  Listbox,
  ListboxButton,
  ListboxOption,
  ListboxOptions
} from '@headlessui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapActions } from 'vuex'

export default defineComponent({
  name: 'AnimationSelector',
  components: {
    FontAwesomeIcon,
    ListboxOption,
    ListboxOptions,
    Listbox,
    ListboxButton
  },
  data() {
    return {
      animation: null
    }
  },
  computed: {
    localAnimation: {
      get() {
        return this.animation
      },
      set(value) {
        this.processSetAnimation(value)
        this.animation = value
      }
    },
    listAnimations() {
      return [
        {
          key: 'none',
          label: 'none'
        },
        {
          key: 'auto',
          label: 'auto'
        },
        {
          key: 'snowflakes',
          label: 'snowflakes'
        }
        // {
        //   key: 'christmasLights',
        //   label: 'christmas lights'
        // }
      ]
    }
  },
  mounted() {
    this.animation = localStorage.getItem('animation') || 'auto'
  },
  methods: {
    ...mapActions({
      processSetAnimation: 'auth/setAnimation'
    })
  }
})
</script>
